import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalSupplierMetadataDocument = gql`
  query SalesPortalSupplierMetadata($supplierUUID: uuid!) {
    businesses_by_pk(uuid: $supplierUUID) {
      uuid
      address {
        country_code
        timezone
        uuid
      }
      supplier_metadata {
        po_number_display
        show_order_notes
      }
    }
  }
`;
export function useSalesPortalSupplierMetadataQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalSupplierMetadataQuery,
    Types.SalesPortalSupplierMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalSupplierMetadataQuery,
    Types.SalesPortalSupplierMetadataQueryVariables
  >(SalesPortalSupplierMetadataDocument, options);
}
export function useSalesPortalSupplierMetadataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalSupplierMetadataQuery,
    Types.SalesPortalSupplierMetadataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalSupplierMetadataQuery,
    Types.SalesPortalSupplierMetadataQueryVariables
  >(SalesPortalSupplierMetadataDocument, options);
}
export type SalesPortalSupplierMetadataQueryHookResult = ReturnType<
  typeof useSalesPortalSupplierMetadataQuery
>;
export type SalesPortalSupplierMetadataLazyQueryHookResult = ReturnType<
  typeof useSalesPortalSupplierMetadataLazyQuery
>;
export type SalesPortalSupplierMetadataQueryResult = Apollo.QueryResult<
  Types.SalesPortalSupplierMetadataQuery,
  Types.SalesPortalSupplierMetadataQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalSupplierMetadataQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalSupplierMetadataQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalSupplierMetadataQuery,
    Types.SalesPortalSupplierMetadataQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalSupplierMetadataQuery,
    Types.SalesPortalSupplierMetadataQueryVariables
  >(SalesPortalSupplierMetadataDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalSupplierMetadataLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalSupplierMetadataLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalSupplierMetadataQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalSupplierMetadataQuery,
    Types.SalesPortalSupplierMetadataQueryVariables
  >(SalesPortalSupplierMetadataDocument, lazyOptions);
}
